import idbKeys from '@/common/idb-key'
import idb from '@/utils/idb'
import { addMinutes } from '@/utils/date'

const CACHE_TIME = window.__env.idbCacheTime || 240 // 4 tiếng

class CacheTime {
  /**
   * @description Kiểm tra dữ liệu cache theo key đã hết hạn chưa
   * @param key cần kiểm tra
   * @returns
   * @author PHNam
   */
  public async IsExpiredTime (key: string): Promise<boolean> {
    const cacheTime: Record<string, any> = await idb.get(idbKeys.CacheTime, {})
    const lastCacheTime: Nullable<Date> = cacheTime[key]

    if (!lastCacheTime) return true

    const now = new Date().getTime()
    const expiredTime = addMinutes(lastCacheTime, CACHE_TIME).getTime()

    return now > expiredTime
  }

  /**
   * @description Lưu lại thời gian gần nhất cache lại dữ liệu
   * @param key key cache
   * @author PHNam
   */
  public async SetCacheTime (key: string): Promise<void> {
    const cacheTime = await idb.get(idbKeys.CacheTime, {})

    cacheTime[key] = new Date()
    await idb.update(idbKeys.CacheTime, cacheTime)
  }
}
export default new CacheTime()
